import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a248e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-registration-container" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "top-container" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Upload Curve Selection Of Restricted Cities Failed ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Re-Upload")
const _hoisted_8 = { class: "failed-reason" }
const _hoisted_9 = { class: "download-button-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-xiazai" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Download Template ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_year_picker = _resolveComponent("year-picker")!
  const _component_upload = _resolveComponent("upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { dataSource: [] })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createVNode(_component_ExclamationCircleOutlined),
            _hoisted_6
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleToUpload
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_a_table, {
          class: "data-table",
          pagination: false,
          columns: _ctx.columns,
          "data-source": _ctx.tableData,
          rowKey: (record, index) => index
        }, {
          FailedReason: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(record.error), 1)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "rowKey"])
      ])
    ]),
    _createVNode(_component_upload, {
      title: "Of Restricted Cities",
      visible: _ctx.visibleUploadDrawer,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleUploadDrawer) = $event)),
      onUpload: _ctx.handleUpload
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_year_picker, {
            value: _ctx.uploadYear,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadYear) = $event)),
            allowClear: false
          }, null, 8, ["value"]),
          _createElementVNode("div", {
            class: "downBtn",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)))
          }, _hoisted_12)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onUpload"])
  ], 64))
}